import { rem } from '@rulebooks/evidend-titan';
import type { CustomComponents } from '@rulebooks/evidend-titan';

const theme: {
  maxParagraphWrapperWidth: string;
  colors: { categorical: string[] };
} = {
  maxParagraphWrapperWidth: rem(572),
  colors: {
    categorical: [
      '#0095DB',
      '#2E247A',
      '#F59C00',
      '#FFDD00',
      '#86BC25',
      '#E82E8A',
      '#A7358C',
      '#CBCACA',
    ],
  },
};

const customComponents: CustomComponents = () => ({
  menu: {
    listItemPadding: {
      default: `${rem(6)} ${rem(8)}`,
      indented: `${rem(12)} ${rem(16)} ${rem(12)} ${rem(40)}`,
    },
  },
});

export { theme, customComponents };
